import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";

@Injectable()
export class DataService_StudentSchedule {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	StudentScheduleFullInfoGetList(PersonID) {
		var postResult$ = new Subject();
		var url = "StudentSchedule/StudentScheduleFullInfoGetList?PersonID=" + PersonID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SemesterSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "StudentSchedule/SemesterSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PeriodSelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "StudentSchedule/PeriodSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	SchoolDaySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "StudentSchedule/SchoolDaySelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
